module.exports = __webpack_public_path__ + "static/media/311554_01big.14a45123.jpg";